
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport08DtGrid extends Serenity.EntityGrid<IcReport08DtRow, any> {
        protected getColumnsKey() { return IcReport08DtColumns.columnsKey; }
        protected getDialogType() { return IcReport08DtDialog; }
        protected getIdProperty() { return IcReport08DtRow.idProperty; }
        protected getInsertPermission() { return IcReport08DtRow.insertPermission; }
        protected getLocalTextPrefix() { return IcReport08DtRow.localTextPrefix; }
        protected getService() { return IcReport08DtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}